import logo from "../assets/logo.png";
import { Link, Route, Routes } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./navbar.css";

function Navbar() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Helper function to read user from localStorage
  const loadUser = () => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        console.error("Failed to parse user from localStorage", e);
        setUser(null);
      }
    } else {
      setUser(null);
    }
  };

  useEffect(() => {
    // 1. Load user when page mounts
    loadUser();

    // 2. Listen for custom 'userLogin' event from Login.js
    window.addEventListener("userLogin", loadUser);

    // 3. Clean up event listener when component unmounts
    return () => {
      window.removeEventListener("userLogin", loadUser);
    };
  }, []);

  // Handlers
  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  const handleChangePassword = () => {
    navigate("/change-password");
  };

  const adminCheck = "admin";

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/">
          <img className="nav-logo" src={logo} alt="The New Mainstream" />
        </Link>
        <nav className="nav-links">
          <Link to="/enquiry">Enquire</Link>
          <a href="#what-we-do">What we do</a>
          <a href="#research-panel">Research Panel</a>
          {user ? (
            <div>
              {user.role === adminCheck && (
                <a href="/content-blocks">Content Blocks</a>
              )}
            </div>
          ) : (
            <p></p>
          )}
          {user ? (
            <div className="nav-user-container">
              <span className="nav-user-info">
                <strong>{user.firstname} </strong>
                <span className="nav-user-role">({user.role})</span>
              </span>
              <br />
              <button onClick={handleChangePassword} className="nav-logout-btn">
                Change Password
              </button>
              <br />
              <button onClick={handleLogout} className="nav-logout-btn">
                Log out
              </button>
            </div>
          ) : (
            <Link to="/login" className="nav-login-btn">
              Login
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
